import {
  Injectable,
  Renderer2,
  RendererFactory2
} from '@angular/core';
import {
  ThemeSideBar
} from '../../common';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas'
import {
  enPdf
} from 'src/app/shared/constant';
import { DashboardService } from 'src/app/shared/services/dashboard.service';
import {saveAs} from 'file-saver'
import 'jspdf-autotable';

@Injectable({
  providedIn: 'root'
})

export class DataSharedService {

  // @Output() cssRefresh = new EventEmitter<boolean>();

  public user;
  public user_id: number;
  public deviceDetail: any = [];
  public device_detail: any = [];
  public paramDetail: any = [];
  public deviceArray: any = [];
  public device_params: any = [];
  public device_id: any;
  public panel_devices: any = [];
  public getlabel: string;
  public category: string;
  public toggleFullScreen: Boolean = false;
  public toggleSidebar: Boolean = true;
  public chart_data: any = [];
  public single_interval: String = null;
  public group_interval: String = null;
  public postpaid_payment_summary: any = [];
  public postpaid_payment_summary_list: any = [];
  public prepaid_payment_summary: any = [];
  public prepaid_payment_summary_list: any = [];
  public billing_table_summary: any = [];
  public billing_table_summary_list: any = [];
  public fixed_interval: String = '';
  public today_genset_kwh: any = 0.00;
  public device_location: any;
  public animated_gauge_value;
  public mot_spd;
  public mot_spd_estm;
  public temp = 0;
  public set_temp = 0;
  public humid = 30;
  public source_type: String = '';
  public geo_location;
  public map_status;
  public relay_status;
  public relay_statu;
  public tank_capacity;
  public volume_filled;
  public timeZone = [];
  public languages_list = {};
  public cities_list = {};
  public states_list = {};
  public nm_site = "";
  device_type = '';

  fromDate: any;
  toDate: any;
  graphParam: any = [];
  order_menu_list: any = [];
  paramters_list: any = [];
  curr_menu: any = ThemeSideBar.dashboardSingleKey;
  curr_tab: string = '';

  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2, private dashboardService: DashboardService) {
    this.orderListMenu(); this.fillParamList(); this.getTimeZone(); this.getLanguages(); this.getCities(); this.getState();
    this.renderer = rendererFactory.createRenderer(null, null);
  }
  public dashboard_data: any = [];

  /**
   * main sidebar menu list
   */
  orderListMenu() {
    this.order_menu_list = {
      // "/dashboard": "dashboard",
      "/dashboard/single": "dashboard~single",
      "/dashboard/collective": "dashboard~collective",
      "/dashboard/comparative": "dashboard~comparative",
      // "/analysis": "analytics",
      "/analysis/energy-consumption": "analysis-energy-consumption",
      "/analysis/level/single": "analysis~energy~single",
      "/analysis/energy/collective": "analysis~energy~collective",
      "/analysis/energy/comparative": "analysis~energy~comparative",
      // "/customer-management": "customer-management",
      "/customer-management/configuration": "customer-management~configuration",
      "/customer-management/new-user": "customer-management~new-user",
      "/customer-management/user-setting": "customer-management~user-setting",
      "/customer-management/device-data-status": "customer-management~device-data-status",
      "/analysis/power-trend": "analysis~power-trend",
      "/analysis/heat-map": "analysis~heat-map",
      "/analysis/share-consumption": "analysis~share-consumption",
      "/analysis/min-max": "analysis~min-max",
      "/pv-net-metering": "pv-net-metering",
      "/pv-string-monitoring": "pv-string-monitoring",
      "/pv-generation-report": "pv-generation-report",
      "/button-management": "button-management",
      "/status": "status",
      "/flow-tracking": "flow-tracking",
      "/alarm-logs": "alarm-logs",
      "/favorite": "favorite-summary",
      "/billing-summary": "billing-summary",
      "/power-monitoring": "power-monitoring",
      "/settings": "settings"
    };
  }

  /**
   * type: Energy
   * key: parameter code
   * value: parameter desc
   */
  fillParamList() {
    this.paramters_list = {
      "3pcos": "3 Phase System Cosphi",
      "airp": "Air Pressure",
      "alh": "Alarm Level High",
      "all": "Alarm Level Low",
      "avg_curr_3p": "Avg. 3 Phase Current",
      "avg_pf_3p": "Power Factor 3 Phase (Avg)",
      "avg_vl_pn": "Avg. Phase Voltage VL-N",
      "avg_vl_pp": "Avg. Line Voltage VL-L",
      "bfvol": "Balanced Filled Volume",
      "cons": "Consumption",
      "ctpc": "CT Primary Current",
      "ctsc": "CT Secondary Current",
      "curr_b": "Line Current L3",
      "curr_r": "Line Current L1",
      "curr_thdf_lb": "Current thdf L3 (Normal Visualization) ABB",
      "curr_thdf_lr": "Current thdf L1 (Normal Visualization) ABB",
      "curr_thdf_ly": "Current thdf L2 (Normal Visualization) ABB",
      "curr_y": "Line Current L2",
      "evol": "Empty Volume",
      "fr": "Flow Rate",
      "frequency": "Frequency",
      "fvol": "Volume Filled",
      "humid": "Humidity %",
      "ltemp": "Liquid Temprature",
      "max_curr_b": "Max. Instantaneous Current L3",
      "max_curr_r": "Max. Instantaneous Current L1",
      "max_curr_y": "Max. Instantaneous Current L2",
      "max_va": "Max. Apparent Power",
      "max_var": "Max. Reactive Power",
      "max_vl_br": "Max. Instantaneous Line Voltage L-31",
      "max_vl_rn": "Max. Instantaneous Phase Voltage L1",
      "max_vl_ry": "Max. Instantaneous Line Voltage L-12",
      "max_vl_yb": "Max. Instantaneous Line Voltage L-23",
      "max_vl_yn": "Max. Instantaneous Phase Voltage L2",
      "max_w": "Max. Active Power",
      "min_var": "Mini. Reactive Power",
      "min_w": "Mini. Active Power",
      "moff": "Motor Off",
      "mon": "Motor On",
      "mos": "Motion Sensor",
      "p1cos": "Phase Cosphi 1",
      "p2cos": "Phase Cosphi 2",
      "p3cos": "Phase Cosphi 3",
      "per": "Percentage %",
      "pf_b": "Power Factor L3 (Blue)",
      "pf_r": "Power Factor L1 (Red)",
      "pf_y": "Power Factor L2 (Yellow)",
      "ph": "PH",
      "ptpv": "PT Primary Voltage",
      "ptsv": "PT Secondary Voltage",
      "pv_nm_max_w": "NM Maximum Active Power",
      "pv_nm_total_w": "NM Total Active Power",
      "pv_nm_total_wh_exp": "NM Export Total Active Energy/3-Q Sys Active Energy",
      "pv_nm_total_wh_imp": "NM Import Total Active Energy/3-Q Sys Active Energy",
      "pv_nm_w_b": "NM Active power L3",
      "pv_nm_w_r": "NM Active power L1",
      "pv_nm_w_y": "NM  Active power L2",
      "pv_st_curr": "String Input Current Value",
      "pv_st_w": "String Input Power Value",
      "pv_st_wh": "String Energy",
      "pv_total_curr": "Inverter Total Confluence Current",
      "pv_total_w": "Inverter Total Confluence Power",
      "pv_total_wh": "Inverter Total Energy",
      "pv_v": "Inverter Power Module DC High Voltage Input",
      "ref": "Refilling",
      "rh": "Run Hour",
      "tb": "Turbidity",
      "tcap": "Tank Capacity",
      "tds": "TDS",
      "temp": "Temperature °C",
      "total_va": "Total Apparent Power",
      "total_vah": "Total Apprant Energy / 3Q Apparent Energy",
      "total_var": "Total Reactive Power",
      "total_varh": "Total Reactive Energy/3Q Sys Reactive Energy",
      "total_w": "Total Active Power",
      "total_wh": "Total Active Energy/3-Q Sys Active Energy",
      "total_wh_exp": "Export Total Active Energy/3-Q Sys Active Energy",
      "total_wh_imp": "NM Import Total Active Energy/3-Q Sys Active Energy",
      "varh_b": "Reactive Energy L3",
      "varh_exp": "Export Reactive Energy/3Q Sys Gen Reactive Energy",
      "varh_imp": "Import Reactive Energy",
      "varh_r": "Reactive Energy L1",
      "varh_y": "Reactive Energy L2",
      "var_b": "Reactive Power L3",
      "var_r": "Reactive Power L1",
      "var_y": "Reactive Power L2",
      "va_b": "Apparent Power L3",
      "va_r": "Apparent Power L1",
      "va_y": "Apparent Power L2",
      "vl_bn": "Phase Voltage V3-N",
      "vl_br": "Line Voltage V-31",
      "vl_rn": "Phase Voltage V1-N",
      "vl_ry": "Line Voltage V-12",
      "vl_thdf_lb": "Voltage thdf L3 (Normal Visualization) ABB",
      "vl_thdf_lr": "Voltage thdf L1 (Normal Visualization) ABB",
      "vl_thdf_ly": "Voltage thdf L2 (Normal Visualization) ABB",
      "vl_yb": "Line Voltage V-23",
      "vl_yn": "Phase Voltage V2-N",
      "wh_b": "Active Energy L3",
      "wh_b_exp": "Export Active Energy L3",
      "wh_b_imp": "NM Import Active Energy L3",
      "wh_exp": "OLD Export Active Energy/3-Q Sys Gen Active Energy",
      "wh_imp": "OLD Import Active Energy",
      "wh_r": "Active Energy L1",
      "wh_r_exp": "Export Active Energy L1",
      "wh_r_imp": "NM Import Active Energy L1",
      "wh_y": "Active Energy L2",
      "wh_y_exp": "Export Active Energy L2",
      "wh_y_imp": "NM Import Active Energy L2",
      "w_b": "Active Power L3",
      "w_r": "Active Power L1",
      "w_y": "Active Power L2",
      "value": "Value",
      '@timestamp': 'Date',
      'date': 'Date',
      'device_id': 'Device',
      'pv_power': 'Pv Power',
      'ke_power': 'KE Power',
      'load_power': 'Load Power',
      'export_to_grid': 'Export To Grid ( KWh )',
      'pv_yield_energy': 'Pv Yield Energy',
      'pv_self_use': 'Pv-Self Use ( KWh )',
      'import_from_grid': 'Import From Grid ( KWh )',
      'buy_from_grid': 'Buying From Grid ( Bill )',
      'sale_to_grid': 'Selling To Grid ( Income )',
      'balance': 'Balance',
      'saving': 'Saving  (Pv-Self Use)',
      'total_saving': 'Total Saving',
      'energy_produce': 'Energy Produce (Kwh)',
      'device': 'Device',
      'date_from': 'Start Date',
      'date_to': 'End Date',
      'pv_yeild_energy': 'Pv-Yield Energy',
      'consumption': 'Consumption',
      'energy_balance': 'Energy Balance',
      'first': 'First',
      'last': 'Last',
      'diff': 'Difference',
      'cost': 'Cost',
      'mot_spd': 'Motor Speed Used',
      'total_fh': 'Total Flow',
      'total_f': 'Instant Flow Rate',
      'co_2': 'Carbon Dioxide CO2',
      'set_temp': 'AC Set Temperature/Humidity',
      'total_cr': 'Refilling Counter',
      'total_cc': 'Consumption Counter',
      'volume': 'Volume',
      'total_w_d': 'Active Power, Total Demand Present'
    };
    this.postpaid_payment_summary = [
      { 'key': 'invoice_id', 'value': 'Invoice ID' },
      { 'key': 'meter_id', 'value': 'Meter ID' },
      { 'key': 'device_model', 'value': 'Device Model' },
      { 'key': 'location', 'value': 'Location' },
      { 'key': 'billing_month', 'value': 'Billing Month' },
      { 'key': 'start_kwh', 'value': 'Start Kwh' },
      { 'key': 'end_kwh', 'value': 'End Kwh' },
      { 'key': 'total_energy_kwh', 'value': 'Total Kwh' },
      { 'key': 'unit_rate_rs', 'value': 'Unit Rate' },
      { 'key': 'total_cost_rs', 'value': 'Total Cost' },
      { 'key': 'service_charges', 'value': 'Service Charges' },
      { 'key': 'misc_charges', 'value': 'Misc Charges' },
      { 'key': 'grand_total_before_due_date', 'value': 'Grand Total Before Due Date' },
      { 'key': 'late_charges', 'value': 'Late Charges' },
      { 'key': 'grand_total_after_due_date', 'value': 'Grand Total After Due Date' },
      { 'key': 'bill_amount', 'value': 'Bill Amount' },
      { 'key': 'available_balance', 'value': 'Available Balance' },
      { 'key': 'receiving_date', 'value': 'Receiving Date' },
      { 'key': 'net_payable', 'value': 'Net Payable' },
      { 'key': 'payment_received', 'value': 'Payment Received' },
      { 'key': 'balance_payment', 'value': 'Balance Payment' },
      { 'key': 'remarks', 'value': 'Remarks' }
    ]
    this.postpaid_payment_summary_list = {
      'invoice_id': 'Invoice ID',
      'meter_id': 'Meter ID',
      'device_model': 'Device Model',
      'location': 'Location',
      'billing_month': 'Billing Month',
      'start_kwh': 'Start Kwh',
      'end_kwh': 'End Kwh',
      'total_energy_kwh': 'Total Kwh',
      'unit_rate_rs': 'Unit Rate',
      'total_cost_rs': 'Total Cost',
      'service_charges': 'Service Charges',
      'misc_charges': 'Misc Charges',
      'grand_total_before_due_date': 'Grand Total Before Due Date',
      'late_charges': 'Late Charges',
      'grand_total_after_due_date': 'Grand Total After Due Date',
      'bill_amount': 'Bill Amount',
      'available_balance': 'Available Balance',
      'receiving_date': 'Receiving Date',
      'net_payable': 'Net Payable',
      'payment_received': 'Payment Received',
      'balance_payment': 'Balance Payment',
      'remarks': 'Remarks'
    }
    this.prepaid_payment_summary = [
      { 'key': 'invoice_id', 'value': 'Invoice ID' },
      { 'key': 'meter_id', 'value': 'Meter ID' },
      { 'key': 'device_model', 'value': 'Device Model' },
      { 'key': 'location', 'value': 'Location' },
      { 'key': 'current_reading_kwh', 'value': 'Current Reading Kwh' },
      { 'key': 'current_reading_end_limit_kwh', 'value': 'Current Reading End Limit Kwh' },
      { 'key': 'unit_rate_rs', 'value': 'Unit Rate' },
      { 'key': 'charge_amount_rs', 'value': 'Charge Amount Rs' },
      { 'key': 'new_charge_unit_kwh_a', 'value': 'New Charge Unit Kwh A' },
      { 'key': 'previous_available_unit_kwh_b', 'value': 'Previous Available Unit Kwh B' },
      { 'key': 'total_unit_kwh_a_b', 'value': 'Total Unit Kwh A B' },
      { 'key': 'charge_date', 'value': 'Charge Date' },
      { 'key': 'remarks', 'value': 'Remarks' }
    ]
    this.prepaid_payment_summary_list = {
      'invoice_id': 'Invoice ID',
      'meter_id': 'Meter ID',
      'device_model': 'Device Model',
      'location': 'Location',
      'current_reading_kwh': 'Current Reading Kwh',
      'current_reading_end_limit_kwh': 'Current Reading End Limit Kwh',
      'unit_rate_rs': 'Unit Rate',
      'charge_amount_rs': 'Charge Amount Rs',
      'new_charge_unit_kwh_a': 'New Charge Unit Kwh A',
      'previous_available_unit_kwh_b': 'Previous Available Unit Kwh B',
      'total_unit_kwh_a_b': 'Total Unit Kwh A B',
      'charge_date': 'Charge Date',
      'remarks': 'Remarks'
    }
    this.billing_table_summary = [
      { 'key': 'invoice_id', 'value': 'Invoice ID' },
      { 'key': 'meter_id', 'value': 'Meter ID' },
      { 'key': 'device_model', 'value': 'Device Model' },
      { 'key': 'billing_month', 'value': 'Billing Month' },
      { 'key': 'location', 'value': 'Location' },
      { 'key': 'start_kwh', 'value': 'Start Kwh' },
      { 'key': 'end_kwh', 'value': 'End Kwh' },
      { 'key': 'current_reading_kwh', 'value': 'Current Reading Kwh' },
      { 'key': 'current_reading_end_limit_kwh', 'value': 'Current Reading End Limit Kwh' },
      { 'key': 'total_energy_kwh', 'value': 'Total Kwh' },
      { 'key': 'unit_rate_rs', 'value': 'Unit Rate' },
      { 'key': 'total_cost_rs', 'value': 'Total Cost' },
      { 'key': 'service_charges', 'value': 'Service Charges' },
      { 'key': 'misc_charges', 'value': 'Misc Charges' },
      { 'key': 'grand_total_before_due_date', 'value': 'Grand Total Before Due Date' },
      { 'key': 'late_charges', 'value': 'Late Charges' },
      { 'key': 'grand_total_after_due_date', 'value': 'Grand Total After Due Date' },
      { 'key': 'charge_amount_rs', 'value': 'Charge Amount Rs' },
      { 'key': 'new_charge_unit_kwh_a', 'value': 'New Charge Unit Kwh A' },
      { 'key': 'previous_available_unit_kwh_b', 'value': 'Previous Available Unit Kwh B' },
      { 'key': 'total_unit_kwh_a_b', 'value': 'Total Unit Kwh A B' },
      { 'key': 'net_payable', 'value': 'Net Payable' },
      { 'key': 'bill_amount', 'value': 'Bill Amount' },
      { 'key': 'available_balance', 'value': 'Available Balance' },
      { 'key': 'payment_received', 'value': 'Payment Received' },
      { 'key': 'balance_payment', 'value': 'Balance Payment' },
      { 'key': 'receiving_date', 'value': 'Receiving Date' },
      { 'key': 'charge_date', 'value': 'Charge Date' },
      { 'key': 'remarks', 'value': 'Remarks' }
    ]
    this.billing_table_summary_list = {
      'invoice_id': 'Invoice ID',
      'meter_id': 'Meter ID',
      'device_model': 'Device Model',
      'billing_month': 'Billing Month',
      'location': 'Location',
      'start_kwh': 'Start Kwh',
      'end_kwh': 'End Kwh',
      'current_reading_kwh': 'Current Reading Kwh',
      'current_reading_end_limit_kwh': 'Current Reading End Limit Kwh',
      'total_energy_kwh': 'Total Kwh',
      'unit_rate_rs': 'Unit Rate',
      'total_cost_rs': 'Total Cost',
      'service_charges': 'Service Charges',
      'misc_charges': 'Misc Charges',
      'grand_total_before_due_date': 'Grand Total Before Due Date',
      'late_charges': 'Late Charges',
      'grand_total_after_due_date': 'Grand Total After Due Date',
      'charge_amount_rs': 'Charge Amount Rs',
      'new_charge_unit_kwh_a': 'New Charge Unit Kwh A',
      'previous_available_unit_kwh_b': 'Previous Available Unit Kwh B',
      'total_unit_kwh_a_b': 'Total Unit Kwh A B',
      'net_payable': 'Net Payable',
      'bill_amount': 'Bill Amount',
      'available_balance': 'Available Balance',
      'payment_received': 'Payment Received',
      'balance_payment': 'Balance Payment',
      'receiving_date': 'Receiving Date',
      'charge_date': 'Charge Date',
      'remarks': 'Remarks'
    }
  }

  getTimeZone() {
    this.timeZone = [
      'Europe/Andorra',
      'Asia/Dubai',
      'Asia/Kabul',
      'Europe/Tirane',
      'Asia/Yerevan',
      'Antarctica/Casey',
      'Antarctica/Davis',
      'Antarctica/DumontDUrville', // https://bugs.chromium.org/p/chromium/issues/detail?id=928068
      'Antarctica/Mawson',
      'Antarctica/Palmer',
      'Antarctica/Rothera',
      'Antarctica/Syowa',
      'Antarctica/Troll',
      'Antarctica/Vostok',
      'America/Argentina/Buenos_Aires',
      'America/Argentina/Cordoba',
      'America/Argentina/Salta',
      'America/Argentina/Jujuy',
      'America/Argentina/Tucuman',
      'America/Argentina/Catamarca',
      'America/Argentina/La_Rioja',
      'America/Argentina/San_Juan',
      'America/Argentina/Mendoza',
      'America/Argentina/San_Luis',
      'America/Argentina/Rio_Gallegos',
      'America/Argentina/Ushuaia',
      'Pacific/Pago_Pago',
      'Europe/Vienna',
      'Australia/Lord_Howe',
      'Antarctica/Macquarie',
      'Australia/Hobart',
      'Australia/Currie',
      'Australia/Melbourne',
      'Australia/Sydney',
      'Australia/Broken_Hill',
      'Australia/Brisbane',
      'Australia/Lindeman',
      'Australia/Adelaide',
      'Australia/Darwin',
      'Australia/Perth',
      'Australia/Eucla',
      'Asia/Baku',
      'America/Barbados',
      'Asia/Dhaka',
      'Europe/Brussels',
      'Europe/Sofia',
      'Atlantic/Bermuda',
      'Asia/Brunei',
      'America/La_Paz',
      'America/Noronha',
      'America/Belem',
      'America/Fortaleza',
      'America/Recife',
      'America/Araguaina',
      'America/Maceio',
      'America/Bahia',
      'America/Sao_Paulo',
      'America/Campo_Grande',
      'America/Cuiaba',
      'America/Santarem',
      'America/Porto_Velho',
      'America/Boa_Vista',
      'America/Manaus',
      'America/Eirunepe',
      'America/Rio_Branco',
      'America/Nassau',
      'Asia/Thimphu',
      'Europe/Minsk',
      'America/Belize',
      'America/St_Johns',
      'America/Halifax',
      'America/Glace_Bay',
      'America/Moncton',
      'America/Goose_Bay',
      'America/Blanc-Sablon',
      'America/Toronto',
      'America/Nipigon',
      'America/Thunder_Bay',
      'America/Iqaluit',
      'America/Pangnirtung',
      'America/Atikokan',
      'America/Winnipeg',
      'America/Rainy_River',
      'America/Resolute',
      'America/Rankin_Inlet',
      'America/Regina',
      'America/Swift_Current',
      'America/Edmonton',
      'America/Cambridge_Bay',
      'America/Yellowknife',
      'America/Inuvik',
      'America/Creston',
      'America/Dawson_Creek',
      'America/Fort_Nelson',
      'America/Vancouver',
      'America/Whitehorse',
      'America/Dawson',
      'Indian/Cocos',
      'Europe/Zurich',
      'Africa/Abidjan',
      'Pacific/Rarotonga',
      'America/Santiago',
      'America/Punta_Arenas',
      'Pacific/Easter',
      'Asia/Shanghai',
      'Asia/Urumqi',
      'America/Bogota',
      'America/Costa_Rica',
      'America/Havana',
      'Atlantic/Cape_Verde',
      'America/Curacao',
      'Indian/Christmas',
      'Asia/Nicosia',
      'Asia/Famagusta',
      'Europe/Prague',
      'Europe/Berlin',
      'Europe/Copenhagen',
      'America/Santo_Domingo',
      'Africa/Algiers',
      'America/Guayaquil',
      'Pacific/Galapagos',
      'Europe/Tallinn',
      'Africa/Cairo',
      'Africa/El_Aaiun',
      'Europe/Madrid',
      'Africa/Ceuta',
      'Atlantic/Canary',
      'Europe/Helsinki',
      'Pacific/Fiji',
      'Atlantic/Stanley',
      'Pacific/Chuuk',
      'Pacific/Pohnpei',
      'Pacific/Kosrae',
      'Atlantic/Faroe',
      'Europe/Paris',
      'Europe/London',
      'Asia/Tbilisi',
      'America/Cayenne',
      'Africa/Accra',
      'Europe/Gibraltar',
      'America/Godthab',
      'America/Danmarkshavn',
      'America/Scoresbysund',
      'America/Thule',
      'Europe/Athens',
      'Atlantic/South_Georgia',
      'America/Guatemala',
      'Pacific/Guam',
      'Africa/Bissau',
      'America/Guyana',
      'Asia/Hong_Kong',
      'America/Tegucigalpa',
      'America/Port-au-Prince',
      'Europe/Budapest',
      'Asia/Jakarta',
      'Asia/Pontianak',
      'Asia/Makassar',
      'Asia/Jayapura',
      'Europe/Dublin',
      'Asia/Jerusalem',
      'Asia/Kolkata',
      'Indian/Chagos',
      'Asia/Baghdad',
      'Asia/Tehran',
      'Atlantic/Reykjavik',
      'Europe/Rome',
      'America/Jamaica',
      'Asia/Amman',
      'Asia/Tokyo',
      'Africa/Nairobi',
      'Asia/Bishkek',
      'Pacific/Tarawa',
      'Pacific/Enderbury',
      'Pacific/Kiritimati',
      'Asia/Pyongyang',
      'Asia/Seoul',
      'Asia/Almaty',
      'Asia/Qyzylorda',
      'Asia/Qostanay', // https://bugs.chromium.org/p/chromium/issues/detail?id=928068
      'Asia/Aqtobe',
      'Asia/Aqtau',
      'Asia/Atyrau',
      'Asia/Oral',
      'Asia/Beirut',
      'Asia/Colombo',
      'Africa/Monrovia',
      'Europe/Vilnius',
      'Europe/Luxembourg',
      'Europe/Riga',
      'Africa/Tripoli',
      'Africa/Casablanca',
      'Europe/Monaco',
      'Europe/Chisinau',
      'Pacific/Majuro',
      'Pacific/Kwajalein',
      'Asia/Yangon',
      'Asia/Ulaanbaatar',
      'Asia/Hovd',
      'Asia/Choibalsan',
      'Asia/Macau',
      'America/Martinique',
      'Europe/Malta',
      'Indian/Mauritius',
      'Indian/Maldives',
      'America/Mexico_City',
      'America/Cancun',
      'America/Merida',
      'America/Monterrey',
      'America/Matamoros',
      'America/Mazatlan',
      'America/Chihuahua',
      'America/Ojinaga',
      'America/Hermosillo',
      'America/Tijuana',
      'America/Bahia_Banderas',
      'Asia/Kuala_Lumpur',
      'Asia/Kuching',
      'Africa/Maputo',
      'Africa/Windhoek',
      'Pacific/Noumea',
      'Pacific/Norfolk',
      'Africa/Lagos',
      'America/Managua',
      'Europe/Amsterdam',
      'Europe/Oslo',
      'Asia/Kathmandu',
      'Pacific/Nauru',
      'Pacific/Niue',
      'Pacific/Auckland',
      'Pacific/Chatham',
      'America/Panama',
      'America/Lima',
      'Pacific/Tahiti',
      'Pacific/Marquesas',
      'Pacific/Gambier',
      'Pacific/Port_Moresby',
      'Pacific/Bougainville',
      'Asia/Manila',
      'Asia/Karachi',
      'Europe/Warsaw',
      'America/Miquelon',
      'Pacific/Pitcairn',
      'America/Puerto_Rico',
      'Asia/Gaza',
      'Asia/Hebron',
      'Europe/Lisbon',
      'Atlantic/Madeira',
      'Atlantic/Azores',
      'Pacific/Palau',
      'America/Asuncion',
      'Asia/Qatar',
      'Indian/Reunion',
      'Europe/Bucharest',
      'Europe/Belgrade',
      'Europe/Kaliningrad',
      'Europe/Moscow',
      'Europe/Simferopol',
      'Europe/Kirov',
      'Europe/Astrakhan',
      'Europe/Volgograd',
      'Europe/Saratov',
      'Europe/Ulyanovsk',
      'Europe/Samara',
      'Asia/Yekaterinburg',
      'Asia/Omsk',
      'Asia/Novosibirsk',
      'Asia/Barnaul',
      'Asia/Tomsk',
      'Asia/Novokuznetsk',
      'Asia/Krasnoyarsk',
      'Asia/Irkutsk',
      'Asia/Chita',
      'Asia/Yakutsk',
      'Asia/Khandyga',
      'Asia/Vladivostok',
      'Asia/Ust-Nera',
      'Asia/Magadan',
      'Asia/Sakhalin',
      'Asia/Srednekolymsk',
      'Asia/Kamchatka',
      'Asia/Anadyr',
      'Asia/Riyadh',
      'Pacific/Guadalcanal',
      'Indian/Mahe',
      'Africa/Khartoum',
      'Europe/Stockholm',
      'Asia/Singapore',
      'America/Paramaribo',
      'Africa/Juba',
      'Africa/Sao_Tome',
      'America/El_Salvador',
      'Asia/Damascus',
      'America/Grand_Turk',
      'Africa/Ndjamena',
      'Indian/Kerguelen',
      'Asia/Bangkok',
      'Asia/Dushanbe',
      'Pacific/Fakaofo',
      'Asia/Dili',
      'Asia/Ashgabat',
      'Africa/Tunis',
      'Pacific/Tongatapu',
      'Europe/Istanbul',
      'America/Port_of_Spain',
      'Pacific/Funafuti',
      'Asia/Taipei',
      'Europe/Kiev',
      'Europe/Uzhgorod',
      'Europe/Zaporozhye',
      'Pacific/Wake',
      'America/New_York',
      'America/Detroit',
      'America/Kentucky/Louisville',
      'America/Kentucky/Monticello',
      'America/Indiana/Indianapolis',
      'America/Indiana/Vincennes',
      'America/Indiana/Winamac',
      'America/Indiana/Marengo',
      'America/Indiana/Petersburg',
      'America/Indiana/Vevay',
      'America/Chicago',
      'America/Indiana/Tell_City',
      'America/Indiana/Knox',
      'America/Menominee',
      'America/North_Dakota/Center',
      'America/North_Dakota/New_Salem',
      'America/North_Dakota/Beulah',
      'America/Denver',
      'America/Boise',
      'America/Phoenix',
      'America/Los_Angeles',
      'America/Anchorage',
      'America/Juneau',
      'America/Sitka',
      'America/Metlakatla',
      'America/Yakutat',
      'America/Nome',
      'America/Adak',
      'Pacific/Honolulu',
      'America/Montevideo',
      'Asia/Samarkand',
      'Asia/Tashkent',
      'America/Caracas',
      'Asia/Ho_Chi_Minh',
      'Pacific/Efate',
      'Pacific/Wallis',
      'Pacific/Apia',
      'Africa/Johannesburg'
    ];
  }

  getLanguages() {
    // length 142
    this.languages_list = {
      "af": "Afrikaans",
      "sq": "Albanian - shqip",
      "am": "Amharic - አማርኛ",
      "ar": "Arabic - العربية",
      "an": "Aragonese - aragonés",
      "hy": "Armenian - հայերեն",
      "ast": "Asturian - asturianu",
      "az": "Azerbaijani - azərbaycan dili",
      "eu": "Basque - euskara",
      "be": "Belarusian - беларуская",
      "bn": "Bengali - বাংলা",
      "bs": "Bosnian - bosanski",
      "br": "Breton - brezhoneg",
      "bg": "Bulgarian - български",
      "ca": "Catalan - català",
      "ckb": "Central Kurdish - کوردی (دەستنوسی عەرەبی)",
      "zh": "Chinese - 中文",
      "zh-HK": "Chinese (Hong Kong) - 中文（香港）",
      "zh-CN": "Chinese (Simplified) - 中文（简体）",
      "zh-TW": "Chinese (Traditional) - 中文（繁體）",
      "co": "Corsican",
      "hr": "Croatian - hrvatski",
      "cs": "Czech - čeština",
      "da": "Danish - dansk",
      "nl": "Dutch - Nederlands",
      "en": "English",
      "en-AU": "English (Australia)",
      "en-CA": "English (Canada)",
      "en-IN": "English (India)",
      "en-NZ": "English (New Zealand)",
      "en-ZA": "English (South Africa)",
      "en-GB": "English (United Kingdom)",
      "en-US": "English (United States)",
      "eo": "Esperanto - esperanto",
      "et": "Estonian - eesti",
      "fo": "Faroese - føroyskt",
      "fil": "Filipino",
      "fi": "Finnish - suomi",
      "fr": "French - français",
      "fr-CA": "French (Canada) - français (Canada)",
      "fr-FR": "French (France) - français (France)",
      "fr-CH": "French (Switzerland) - français (Suisse)",
      "gl": "Galician - galego",
      "ka": "Georgian - ქართული",
      "de": "German - Deutsch",
      "de-AT": "German (Austria) - Deutsch (Österreich)",
      "de-DE": "German (Germany) - Deutsch (Deutschland)",
      "de-LI": "German (Liechtenstein) - Deutsch (Liechtenstein)",
      "de-CH": "German (Switzerland) - Deutsch (Schweiz)",
      "el": "Greek - Ελληνικά",
      "gn": "Guarani",
      "gu": "Gujarati - ગુજરાતી",
      "ha": "Hausa",
      "haw": "Hawaiian - ʻŌlelo Hawaiʻi",
      "he": "Hebrew - עברית",
      "hi": "Hindi - हिन्दी",
      "hu": "Hungarian - magyar",
      "is": "Icelandic - íslenska",
      "id": "Indonesian - Indonesia",
      "ia": "Interlingua",
      "ga": "Irish - Gaeilge",
      "it": "Italian - italiano",
      "it-IT": "Italian (Italy) - italiano (Italia)",
      "it-CH": "Italian (Switzerland) - italiano (Svizzera)",
      "ja": "Japanese - 日本語",
      "kn": "Kannada - ಕನ್ನಡ",
      "kk": "Kazakh - қазақ тілі",
      "km": "Khmer - ខ្មែរ",
      "ko": "Korean - 한국어",
      "ku": "Kurdish - Kurdî",
      "ky": "Kyrgyz - кыргызча",
      "lo": "Lao - ລາວ",
      "la": "Latin",
      "lv": "Latvian - latviešu",
      "ln": "Lingala - lingála",
      "lt": "Lithuanian - lietuvių",
      "mk": "Macedonian - македонски",
      "ms": "Malay - Bahasa Melayu",
      "ml": "Malayalam - മലയാളം",
      "mt": "Maltese - Malti",
      "mr": "Marathi - मराठी",
      "mn": "Mongolian - монгол",
      "ne": "Nepali - नेपाली",
      "no": "Norwegian - norsk",
      "nb": "Norwegian Bokmål - norsk bokmål",
      "nn": "Norwegian Nynorsk - nynorsk",
      "oc": "Occitan",
      "or": "Oriya - ଓଡ଼ିଆ",
      "om": "Oromo - Oromoo",
      "ps": "Pashto - پښتو",
      "fa": "Persian - فارسی",
      "pl": "Polish - polski",
      "pt": "Portuguese - português",
      "pt-BR": "Portuguese (Brazil) - português (Brasil)",
      "pt-PT": "Portuguese (Portugal) - português (Portugal)",
      "pa": "Punjabi - ਪੰਜਾਬੀ",
      "qu": "Quechua",
      "ro": "Romanian - română",
      "mo": "Romanian (Moldova) - română (Moldova)",
      "rm": "Romansh - rumantsch",
      "ru": "Russian - русский",
      "gd": "Scottish Gaelic",
      "sr": "Serbian - српски",
      "sh": "Serbo-Croatian - Srpskohrvatski",
      "sn": "Shona - chiShona",
      "sd": "Sindhi",
      "si": "Sinhala - සිංහල",
      "sk": "Slovak - slovenčina",
      "sl": "Slovenian - slovenščina",
      "so": "Somali - Soomaali",
      "st": "Southern Sotho",
      "es": "Spanish - español",
      "es-AR": "Spanish (Argentina) - español (Argentina)",
      "es-419": "Spanish (Latin America) - español (Latinoamérica)",
      "es-MX": "Spanish (Mexico) - español (México)",
      "es-ES": "Spanish (Spain) - español (España)",
      "es-US": "Spanish (United States) - español (Estados Unidos)",
      "su": "Sundanese",
      "sw": "Swahili - Kiswahili",
      "sv": "Swedish - svenska",
      "tg": "Tajik - тоҷикӣ",
      "ta": "Tamil - தமிழ்",
      "tt": "Tatar",
      "te": "Telugu - తెలుగు",
      "th": "Thai - ไทย",
      "ti": "Tigrinya - ትግርኛ",
      "to": "Tongan - lea fakatonga",
      "tr": "Turkish - Türkçe",
      "tk": "Turkmen",
      "tw": "Twi",
      "uk": "Ukrainian - українська",
      "ur": "Urdu - اردو",
      "ug": "Uyghur",
      "uz": "Uzbek - o‘zbek",
      "vi": "Vietnamese - Tiếng Việt",
      "wa": "Walloon - wa",
      "cy": "Welsh - Cymraeg",
      "fy": "Western Frisian",
      "xh": "Xhosa",
      "yi": "Yiddish",
      "yo": "Yoruba - Èdè Yorùbá",
      "zu": "Zulu - isiZulu"
    };
  }

  getCities() {
    // length 158
    this.cities_list = {
      "karachi": "Karachi",
      "lahore": "Lahore",
      "faisalabad": "Faisalabad",
      "rawalpindi": "Rawalpindi",
      "hyderabad": "Hyderabad",
      "islamabad": "Islamabad",
      "gujranwala": "Gujranwala",
      "peshawar": "Peshawar",
      "multan": "Multan",
      "quetta": "Quetta",
      "bahawalpur": "Bahawalpur",
      "sargodh": "Sargodh",
      "sialkot": "Sialkot",
      "sukkur": "Sukkur",
      "larkana": "Larkana",
      "saidu_sharif": "Saidu Sharif",
      "chiniot": "Chiniot",
      "shekhupura": "Shekhupura",
      "jhang": "Jhang",
      "dera_Ghazi_Khan": "Dera Ghazi Khan",
      "gujrat": "Gujrat",
      "rahimyar_Khan": "Rahimyar Khan",
      "kasur": "Kasur",
      "mardan": "Mardan",
      "mingaora": "Mingaora",
      "nawabshah": "Nawabshah",
      "sahiwal": "Sahiwal",
      "mirpur_Khas": "Mirpur Khas",
      "okara": "Okara",
      "mandi_Burewala": "Mandi Burewala",
      "jacobabad": "Jacobabad",
      "saddiqabad": "Saddiqabad",
      "kohat": "Kohat",
      "muridke": "Muridke",
      "muzaffargarh": "Muzaffargarh",
      "khanpur": "Khanpur",
      "gojra": "Gojra",
      "mandi_Bahauddin": "Mandi Bahauddin",
      "abbottabad": "Abbottabad",
      "turbat": "Turbat",
      "dadu": "Dadu",
      "bahawalnagar": "Bahawalnagar",
      "khuzdar": "Khuzdar",
      "pakpattan": "Pakpattan",
      "tando_Allahyar": "Tando Allahyar",
      "ahmadpur_East": "Ahmadpur East",
      "vihari": "Vihari",
      "jaranwala": "Jaranwala",
      "new_Mirpur": "New Mirpur",
      "kamalia": "Kamalia",
      "kot_Addu": "Kot Addu",
      "nowshera": "Nowshera",
      "swabi": "Swabi",
      "khushab": "Khushab",
      "dera_Ismail_Khan": "Dera Ismail Khan",
      "chaman": "Chaman",
      "charsadda": "Charsadda",
      "kandhkot": "Kandhkot",
      "chishtian": "Chishtian",
      "hasilpur": "Hasilpur",
      "attock_Khurd": "Attock Khurd",
      "muzaffarabad": "Muzaffarabad",
      "mianwali": "Mianwali",
      "jalalpur_Jattan": "Jalalpur Jattan",
      "bhakkar": "Bhakkar",
      "zhob": "Zhob",
      "dipalpur": "Dipalpur",
      "kharian": "Kharian",
      "mian_Channun": "Mian Channun",
      "bhalwal": "Bhalwal",
      "jamshoro": "Jamshoro",
      "pattoki": "Pattoki",
      "harunabad": "Harunabad",
      "kahror_Pakka": "Kahror Pakka",
      "yoba_Tek_Singh": "Toba Tek Singh",
      "samundri": "Samundri",
      "shakargarh": "Shakargarh",
      "sambrial": "Sambrial",
      "shujaabad": "Shujaabad",
      "hujra_Shah_Muqim": "Hujra Shah Muqim",
      "kabirwala": "Kabirwala",
      "mansehra": "Mansehra",
      "lala_Musa": "Lala Musa",
      "chunian": "Chunian",
      "nankana_Sahib": "Nankana Sahib",
      "bannu": "Bannu",
      "pasrur": "Pasrur",
      "timargara": "Timargara",
      "parachinar": "Parachinar",
      "chenab_Nagar": "Chenab Nagar",
      "gwadar": "Gwadar",
      "abdul_Hakim": "Abdul Hakim",
      "hassan_Abdal": "Hassan Abdal",
      "tank": "Tank",
      "hangu": "Hangu",
      "risalpur_Cantonment": "Risalpur Cantonment",
      "karak": "Karak",
      "kundian": "Kundian",
      "umarkot": "Umarkot",
      "chitral": "Chitral",
      "dainyor": "Dainyor",
      "kulachi": "Kulachi",
      "kalat": "Kalat",
      "kotli": "Kotli",
      "gilgit": "Gilgit",
      "narowal": "Narowal",
      "khairpur_Miras": "Khairpur Miras",
      "khanewal": "Khanewal",
      "jhelum": "Jhelum",
      "haripur": "Haripur",
      "shikarpur": "Shikarpur",
      "rawala_Kot": "Rawala_Kot",
      "hafizabad": "Hafizabad",
      "lodhran": "Lodhran",
      "malakand": "Malakand",
      "attock": "Attock",
      "batgram": "Batgram",
      "matiari": "Matiari",
      "ghotki": "Ghotki",
      "naushahro_Firoz": "Naushahro Firoz",
      "alpurai": "Alpurai",
      "bagh": "Bagh",
      "daggar": "Daggar",
      "leiah": "Leiah",
      "tando_Muhammad_Khan": "Tando Muhammad Khan",
      "chakwal": "Chakwal",
      "badin": "Badin",
      "lakki": "Lakki",
      "rajanpur": "Rajanpur",
      "dera_Allahyar": "Dera Allahyar",
      "shahdad_Kot": "Shahdad Kot",
      "pishin": "Pishin",
      "sanghar": "Sanghar",
      "upper_Dir": "Upper Dir",
      "thatta": "Thatta",
      "dera_Murad_Jamali": "Dera Murad Jamali",
      "kohlu": "Kohlu",
      "mastung": "Mastung",
      "dasu": "Dasu",
      "athmuqam": "Athmuqam",
      "loralai": "Loralai",
      "barkhan": "Barkhan",
      "musa_Khel_Bazar": "Musa Khel Bazar",
      "ziarat": "Ziarat",
      "gandava": "Gandava",
      "sibi": "Sibi",
      "dera_Bugti": "Dera Bugti",
      "eidgah": "Eidgah",
      "uthal": "Uthal",
      "chilas": "Chilas",
      "panjgur": "Panjgur",
      "gakuch": "Gakuch",
      "qila_Saifullah": "Qila Saifullah",
      "kharan": "Kharan",
      "aliabad": "Aliabad",
      "awaran": "Awaran",
      "dalbandin": "Dalbandin",
    }

  }

  getState() {
    this.states_list = {
      "balochistan": "Balochistan",
      "punjab": "Punjab",
      "sindh": "Sindh",
      "khyber_pakhton_khawa": "Khyber Pakhton khawa",
      "gilgit_baltistan": "Gilgit Baltistan"
    }
  }

  /**
   * get title by param code
   * @param String key
   */
  getTitleByParamCode(key) {
    if (this.paramters_list[key]) return this.paramters_list[key];
    if (key && key.startsWith('val_') && this.paramters_list[key.substring(4)]) {
      return this.paramters_list[key.substring(4)];
    }
    return key;
  }

  getTitleBySummaryCode(key) {
    if (this.postpaid_payment_summary_list[key]) return this.postpaid_payment_summary_list[key];
    if (this.prepaid_payment_summary_list[key]) return this.prepaid_payment_summary_list[key];
    return key;
  }

  toggleCardFullsreen(e) {

    this.toggleFullScreen = !this.toggleFullScreen;
    let toggle_class = 'full-screen';
    let card_class = e.target.parentNode.parentNode.parentNode;

    if (this.toggleFullScreen) {

      this.renderer.addClass(card_class, toggle_class);
      this.renderer.removeClass(e.target, 'feather-maximize-2');
      this.renderer.addClass(e.target, 'feather-minimize-2');

    } else {

      this.renderer.removeClass(card_class, toggle_class);
      this.renderer.removeClass(e.target, 'feather-minimize-2');
      this.renderer.addClass(e.target, 'feather-maximize-2');

    }

  }

  /**
   * export data as CSV format
   * @param data
   */
  exportDataAsCsvFormat(data, elemt?) {
    const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    let csv = data.map(row => {
      let newRow: any = { ...row };
      if (newRow.date) newRow.date = this.getDateTime(newRow.date);
      if (newRow.timestamp) newRow.timestamp = this.getDateTime(newRow.timestamp);
      if (newRow['@timestamp']) newRow['@timestamp'] = this.getDateTime(newRow['@timestamp']);
      return header.map(field_name => JSON.stringify(newRow[field_name], replacer)).join(',');
    });
    csv.unshift(this.getHeader(header).join(',').toUpperCase());
    let csv_array = csv.join('\r\n');
    var blob = new Blob([csv_array], {
      type: 'text/csv'
    });
    
    if (elemt == 'collective-table') {
      saveAs(blob, `collective-table.csv`);
    } else if (this.curr_menu == 'pv-generation-report') {
      saveAs(blob, `${this.curr_menu}.csv`);
    } else if (this.device_detail.location != undefined) {
      saveAs(blob, `${(this.device_detail.location.replace(/\s+|->/gi, '_')).toLowerCase()}.csv`);
    } else {
      saveAs(blob, `net_metering.csv`);
    }
  }

  /**
   * header
   * @param header
   */
  getHeader(data) {
    let header = [];
    data.map((i) => { header.push(this.getTitleByParamCode(i)) });
    return header;
  }

  /**
 * get date and time from date() formate
 * @param data
 */
  getDateTime($data) {
    if (typeof $data === 'string' && ($data.includes(',') || $data.includes(' AM') || $data.includes(' PM'))) {
      return $data;
    }

    let date_ob = new Date($data);

    if (isNaN(date_ob.getTime())) {
      return $data;
    }

    let date = ("0" + date_ob.getDate()).slice(-2);

    let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);

    let year = date_ob.getFullYear();

    let hours = ("0" + date_ob.getHours()).slice(-2);

    let minutes = ("0" + date_ob.getMinutes()).slice(-2);

    let seconds = ("0" + date_ob.getSeconds()).slice(-2);

    // prints date & time in YYYY-MM-DD HH:MM:SS format
    return (year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds);
  }

  /**
  * export data as PDF format
  * @param data
  */

  Convert_HTML_To_PDF(pdfUrl) {

    let DATA = document.getElementById(pdfUrl);

    html2canvas(DATA).then(canvas => {

      let fileWidth = 208;
      let fileHeight = canvas.height * fileWidth / canvas.width;

      const FILEURI = canvas.toDataURL('image/png')
      let PDF = new jsPDF('p', 'mm', 'a4');
      let position = 0;
      PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight)

      PDF.save('angular-demo.pdf');
    });
  }

  /**
   * get apis body
   */
  getBody(action, date_from, date_to, params, type) {

    let body = {
      'action': action,
      'user_id': [localStorage.getItem('user')],
      'device_id': [this.device_id],
      'date': date_from,
      'fixed_interval': this.fixed_interval,
      'parameters': params
    };

    if (date_from != date_to) {

      let range = {
        from: date_from,
        to: date_to,
      };

      delete body['date'];
      body['range'] = range
    }

    if (action == 'getEnergyYearlyData') {
      delete body['range']; delete body['fixed_interval'];
      body['year'] = date_from;
    }

    if (action == 'getEnergyProfileandChainAnalysis') {
      delete body['date']; delete body['fixed_interval'];
      body['type'] = type;
    }
    if (action == 'getTabularDataByAccount') {
      delete body['fixed_interval'];
      body['from'] = 0;
      body['size'] = 24;
      body['sort'] = 'desc';
    }
    return body;
  }

  getMotorTorqueValue(date, reset = true) {
    let VFD_value = 0;
    let body = {
      "action": "getTabularDataByAccount",
      "user_id": [localStorage.getItem('user')],
      "device_id": [this.device_id],
      "date": date,
      "parameters": ["mot_torq"],
      "sort": "desc",
      "from": 0,
      "size": 1
    }

    this.dashboardService.httpPost(body).subscribe((res: any) => {

      VFD_value = res.data.hits[0].mot_torq;
    })
    return VFD_value;
  }

  exportDataAsPdfFormat(data, e, elemt, firstDate?, endDate?) {
    const header = this.getHeader(Object.keys(data[0]));

    let data_body = [];
    data.forEach((item) => {
      let newItem: any = { ...item };
      if (newItem.date) {
        newItem.date = this.getDateTime(newItem.date);
      } else if (newItem.timestamp) {
        newItem.timestamp = this.getDateTime(newItem.timestamp);
      } else if (newItem['@timestamp']) {
        newItem['@timestamp'] = this.getDateTime(newItem['@timestamp']);
      }
      data_body.push(Object.values(newItem));
    });

    for (let i = 0; i < data_body.length; i++) {
      for (let j = 0; j < data_body[i].length; j++) {
        if ((typeof data_body[i][j]) == 'number') {
          data_body[i][j] = data_body[i][j].toFixed(1);
        }
      }
    }

    // Calculate the sums for each column except for the 'date' or 'timestamp' column
    const sumRow = header.map((col, index) => {
      if (col.toLowerCase() === 'date' || col.toLowerCase() === 'timestamp') {
        return 'Total';
      }
      const sum = data.reduce((acc, item) => {
        const value = Object.values(item)[index];
        return acc + (typeof value === 'number' ? value : 0);
      }, 0);
      return sum.toFixed(1);
    });

    data_body.push(sumRow);

    let graph_header = []
    graph_header.push(header)

    let pdf_config;
    let m = { fd: { mt: 0, ml: 0 }, ed: { mt: 0, ml: 0 }, dl: { mt: 0, ml: 0 }, u: { mt: 0, ml: 0 }, pt: { mt: 0, ml: 0 } };

    if (header.length > 4) {
      pdf_config = new jsPDF('l', 'mm', 'A4');
      m = { fd: { mt: 15, ml: 254.5 }, ed: { mt: 19, ml: 262 }, dl: { mt: 14, ml: 113 }, pt: { mt: 8, ml: 115 }, u: { mt: 8, ml: 250 }, };
    }
    else {
      pdf_config = new jsPDF();
      m = { fd: { mt: 15, ml: 169.5 }, ed: { mt: 19, ml: 177 }, dl: { mt: 16, ml: 76 }, pt: { mt: 10, ml: 76 }, u: { mt: 8, ml: 165 }, };
    }

    pdf_config.setFillColor(152, 221, 252);
    pdf_config.rect(0, 23, 300, 300);

    pdf_config.setFontSize(16);
    pdf_config.setTextColor("#062a73");
    let xOffset = pdf_config.internal.pageSize.width / 2
    pdf_config.text(`Parameter table for:`, xOffset, m.pt.mt, { align: 'center' });

    pdf_config.setFontSize(16);
    pdf_config.setTextColor("#062a73");

    if (elemt == 'report_table') {
      pdf_config.text('Pv Real Time Generation Report', xOffset, m.dl.mt, { align: 'center' })
    } else if (elemt == 'collective-table') {
      pdf_config.text('Collective table', xOffset, m.dl.mt, { align: 'center' })
    } else {
      (this.device_detail.location != undefined) ? pdf_config.text(`(${this.device_detail.location})`, xOffset, m.dl.mt, { align: 'center' }) : pdf_config.text(`Net Metering`, 11, 12);
    }

    pdf_config.setFontSize(8);

    let first_date_raw = data[0].date || data[0]['timestamp'] || data[0]['@timestamp'];
    let end_date_raw = data[data.length - 1].date || data[data.length - 1]['timestamp'] || data[data.length - 1]['@timestamp'];
    
    let first_date = first_date_raw ? this.getDateTime(first_date_raw) : '';
    let end_date = end_date_raw ? this.getDateTime(end_date_raw) : '';

    if (firstDate && endDate) {
      pdf_config.text(`Date: ${firstDate}`, m.fd.ml, m.fd.mt)
      pdf_config.text(`${endDate}`, m.ed.ml, m.ed.mt);
    } else {
      if (first_date) pdf_config.text(`Date: ${first_date}`, m.fd.ml, m.fd.mt)
      pdf_config.text(`${end_date}`, m.ed.ml, m.ed.mt);
    }

    pdf_config.setFontSize(8);
    // var imgData = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAY0AAABlCAYAAACxx7+KAAAABmJLR0QA/wD/AP+gvaeTAAAo20lEQVR42u1dCXgbxfV3Ar5CgHIUSmIbSDkKlJY2/UNj2cYtR4FCCy0piSWZQCEtLTc0QGMbcR+FcpQrFHBsx7a0shMggYYzHOUoV7hCwp0QCCGS4twJOez/e7Oztizt7szu7K5kad73zZfYlnZnZ3ffb971ewUFOSLTZs8e0d7Vtf/0jq5D2tvbdymQIkWKFClSBgHFtGmFLeHon1ojyoswtsHo6x9hZWFbJHr1A4qyq1wpKVKkSMlzaVaUw1rCykeDgEJ/9LQqSp1cMSlSpEjJUwEQOBLAYB0HYGijtzUSnSJXTooUKVLyzcLo7NwHQCBuATD6gQNcWb+VKyhFihQpeSQtkWjEBmBo40sMmMtVlMIrI6vP+G5xVfD8kqpgO/w7u7gq8EBRtf9U+NMwuTpSpGS5tHd3j1FdTbZBo68lEjlTrqQUHin2Bc4FkFgPoy91AIj8r6jGf6hcJSlSslhaI5GLRACDjkfzUgFW+btB0b2RyQFzeGrorFfgYj2wSB5F1YF4aVV9hXwzpUjJVtAIK83CoBFWFucnaAQWsZSgB2PFUFirkZXBPWCum3iuqagq0CLfTClSstbSUOY4YGlslKAhQcNMwCoKWrimmHwzpUjJUoEgeIcDoPG1BA0JGqagUe0/28I1rZdvphQp2eueulYYNBTlJQkaEjTMBAPcZL4+jmvyBZ6Xb6YUKVkqbZ3RSgdAY6oEDQkabBdVIMJxPb0AGsfIN1OKlCyVUCg0HJT+OyLxjIc6O8slaGRsPD1kFuzY4A4w3zkm17Kh2Bf8s3wrpUjJdmtDUY6xXasB7q18XbfSmgnlJVV1Y9wYRb7AHzgAY8sQrGsYhoV8MPcnYayBsRXGAijyu7+ksm5v+TZKkTJEBKyNJhug8dS8efO2l6vnsNTWbg+KdD4bNPx35ICtO1zecClShq7FcQEAwVbOOIbS2tq6g1w156XY57+Qw8r4pqB20nfkakmRIiWzwBEO/xRAYW5aL40Bd9T7bZHI7/v6+iRPkAtCi+B6WKBRUuWX1C1SpEjJHuno6NgTwGEi0p+j66otHD2jNRw+SK6Mu1Lk8zezASP4hnTrSJEiRUqeS6nP/3OScmoOGtsKq+sOd/zk48dvp7LP1h+Ag/A/VdXtgvGVnF3wbLq+ceNLS2on7VNUEzyouKZu/9Jaf1nB2MmFWblu6BZ1wzV6yPiinH/mpEhxTkLDoY7hdY5YxgOiZ0JQgHPVQyD9LnrO1Sbn+xY+9z78Gy2uDvyteFxgP9snHjt5RElV/dFmAzKrDjY7BAJbYVXdWLMBCnjX1O8An9VEGA9BltZCJEVMAWfM4lqM6cBFvuAVAJhVBS7TtO9QO+l7MJe/wjlnwlhisFnYjGndaH3i/HH9HFHKZuP484oHWb4AYrgmWHAJc1mqPg+DNzEwPoU43MNgAU8e4ZswincuRdV1v4Xv3kOfwTUpx8WfP4O/dZRUB85CQB1skZ9+COtZQiDuf+YBiFmfL/QFf+boJhCeI9Y5M0LOueely3cob0qcUdYY+3d5Y/wpHGWN8bbyhvg5o0Jrds8GdQgx81Jg0z2pLazcDDGRVvh/C4zrgVL9aOxJLgGDcDNN5gCMHox52Dk+sSLUAPvbDtSGvFNUFRxvVbGC4jlQFBSpomURHk4kL21l/ThUZlSxWb3GBSRuhIrWQSmsrDsM2ZExXTolE45nTquLq4O34b20c268ZxznuADvK035tvOsrE1W1mkCtTqwMWjCRA6Lx+2FTcsjpTWBSvVaAi1sN27dmIFr95/CcY5VTt1vGpvcyjpnYaX//zzcmPZtX94YuxQAYhWMPoOxYXRj7Nayi5aWZkIRIiBATOQSCKAnzJo4QbzkrLwOrMPOGEn62A918HzLux2oJYGd9Qy6a3W0sBBe/peLxk38QbaBBio+Wn3e6wRACllXmvjO3BFrUQbm5BeZ02o7iRBcoFEd+AcWjNqdG6x7p/HGqP5o+MyXto49iH7GP5fW+XCDBlpQPAkmxZX+Y53ZBAbO4LiuRZ7pmDGXrdwZAOO/JmCROhaUh2KjvNSDLTNn7gYB9HkWqEi68zWFFx6euzkesHct+XprJ5WAkmiAF2yDyxXpqzAWkw2gUTTYZeLoNYooE3rdnzgP2oHpVuIenJaG4JzqdNs/g4V0kQv3hR801Ot/kON7dzv0Ts/i2HQ1eaJgxk7uKyxrir9iATC0sRDBxos5Njc3l7RElFdsFAv+B1xZ2+UTYKjuCrYZCzuXWgu7nFr0B3v3cgYTaNFkEWi4MVbj/C3f35r6n+D6uDYvcL/xbiY8AI2e1JgIve+XZoJiJxU0qKXD+t5S4XgWuOfgOOuY7rbK07/viZIZ3RS72gZg0JGY5sUcIXZxq+3WsYpycR5hxjB4eF5kPvzVwbClXQ48jFymuLNjTo6DBolzmPrrU8G7JrgvfGe5e/PRXFz+u7IBNDDRIP1++U/ULIwisWMLgwZmCMLvlzHjDIIBcXrNTNeuJxqmLLR6V1D+6+2DRry3rGHF/m7OEdxMFaD8NwkQICZmzJixU14Ev6v9AY6Hfx1Jv7TuEvmNBZ8+BmWXYo9u8Gk/AYr5Wfj5g/RgrdjL5mFMw7SdLPz7Hh1Lrcc9/H/hugEQUOXMhtPGRnRBoq8eFORLVn3/cF0nZ9zSSGEnVlO4eWJ1/WMZefbIM0hodJY5aWlQt9Ht7E1a4Gox0CCxK2eeI2HQaIyfKwAY2rjJVSsjErlMlGodAuP+nEcMEhgNfMVUBpDuaD8YF7zBOJgY+ACU05WwG/4lZrQY+EJHFFUHJ6iEglxuqhuyFDQ+BKX6dz0lgkkI9Brn97sNzI/1Ke5YmWvvC17FObclmP6Mz0Oaa6sq8GNYs39zAtvXesdwADTexjUnWT7ac3L0+J3xZ0w4wB711JJYnuom4ylUpeM5zHTTTeSAlFQAkXNgHZ6xmm2md79Lq4JH8CQ/2H+xQ8M5wG7zjrUTvclshXRaRRg0IB7iqqUBJIbCoBGJTs/54LeapcJ6eD/S8xFzC5rjaS9bIKqlLVoJqmsZNUUs9012gUaMKGS+YGEht5KrDv7KFDCgpoDQvLOz4WYbAvagdfMfz+Ejx3tzpXOgEfyCdZ39ihgs4VQrg97rrWzljq41PnaDEl+gGr7zgoilQV3Cn9j8LnstuEAJ7rtXArUXbzpgaSRcBo0PHWgf+2wuAwamqeoUSemY+8ETRM9F88XR1fGOlWB6qmDRFo8iLKgdPzI7QCP4rOV6BnApkRRblkLxBa4zn2PgPq7uhBY2BHA9J7ESJjDgbhZz4QcN/1zRim84zjQuvz6H1Zam9Kv95/GkkBspfnQ/cSQYXGjTur+W7T3wn+aZsilriL3jAGjEXQWNsLJYFDQw8yrHrYwnvNyNkKpT6y+nniKYxbI2zHZonoEGrK+VgHXKSx8UaUdL/fgscF1vJ3OGJzUb6wNEQAPjWjzWj7llOn6kToV3ei8YCzU+adeiFgjaAg1kHeB4DufZfEfeZRx3jXBlv7WYRmKOA6CxwOVA+KsOtI/tzlkrg68ydZNn6XiW5o51H+ZzN6vZ8Cp7SqsIF1B4LLdKj8k1nsvyuYNiv1HAamQp4ycFLY0LhJ8TngZimCostoG5WMTFZN6vhty7LTseXr+btQ1H3Riu2hovpawpFnIANB501z0VvUPcPRWdkpOIgfnbPv/nHLu9rOyGiK1YRSpqhwRoqArlA1aOvVFthGkKtZqIsM2uv5wqflaB2mYj15JnoMFB8SHqeuWp/TBbZ0h+mMJhtdVbfG4uYB8TOLG8lIrQN2NA6W8TAQ2o8/iFm3OcHonUCILGtvaurv1zETPgIQzxBCCF3QNuzd8X/KNIkHjIgEZ14DHWPHWzX47w76SmKfttuba47kG1/ygO99yvMwkaJIjOSC8WSvDgVvrGoEGysphZaf5ui0D2DGNOXznhJrYkSEAoWKfhSUEJFOg9bRs0gNAwJwFDLfTawA6SBf6QtdeQJ6CBxZTMeerwUfEUdWEqrtBNgCwv1nNkFKj3AjRowgTrHC844Oa9XDQDiiMTax1mDnJNCBiCOYLzt3r+0gLf1G0CgLFuVEPsQC/mic2aAABW2QCNL9u6u/fKRdCgbKvMjB/vZhQaTno3gDsJlYnKshv8K9JQQ6DwVNKzA6my8xA0VAp11jzrD9D53pVeuCfgOP9lnOfRTIEGup14SBGFQQPqboRBA+s/2JlkJ3KCWB2z+BUoZTwGjPj/geLfYhMw1kLmVa2X84V+48cACKyxABgrpivK2JwEDFCkOsV16dkk0CPAzXmgSQ6WTCMWU3EEVPu5eOCFaFX7b7CDj7kBGjzEdumgQXqOML6HfTQciC3dySpmzBhocPj1UVmLWxrspAwWaKCLkWkdQHGlQ9bpAk+Vzp6h5XuA4l+sSwvCUcxX0Zg4JBPKcoaiHNoWUd7gqcto7+7eOxcBg+b+L+JQtre5BhZQzEeppN1nGc1n0PAF3mJlxRU40NwJdr+XMNM6MwUa8Bx7UX8kknJrMX61nFl8qL7jqxhZU3/3OI4RezsFDDYjHcg+oRXfg78dObox3lzWEH8PXVAwemC8X9aQuH90Q/yX0Hcjo72ksU8GxDhOgVhFGN1PMLbC2AxjCVZ+Tw9Hjy3IYeEJ2JEHE6gZHD85HJPm9m/jsHQkaIhbGl+zsq7AYlspOkidByu7Syfg6gVo8Lj2imr8hwrH1ziSSnhAg4f/jcWggNXwzPue0nnQRcCI/RRA4bMUwPgCXVVDVYki9Xm+NFwqHVc/GjuZiRRk2d7xqUy3HznQ8EeCBj9obPVsnVmV+SnxKO9iGoEu5vPugAKFJlTXOEIFotblMEDYfxPDWvmX24H/FGBYNkLXumhK3EwtikGAsXfDqn0LpAwJgeByOwdf0Ku83DsWwWpJRhRWvoKG2hmuL1uGnmL2xj3FZjtwIq6DGWJO8Uex4xHBhYw4zmJGXORPQhdb0RgbS7Og3oexUctswnRYGJcTVxMGrnVat6LlIVXxEAGMmroakgfuM6063eZ0M3vaM+C/GVNY+Qoaqiswa0CjqDL4wwy5p15hWkEOuGLTGJwFQAO7DXJQx+hmntImambf/RaZlG1dJPbCALCIcAWv9YryGuJXeKr1xvdtB703TiA9xhtj/wGX2FMwj5nwb8OoUPwHGdXI0B99dFP8KKBV+QfMaRadWzuZa0PiApjv5IwCLFQL8xDf8WZmWNzpncOtWMDKQfI2JFDD1FtMB1W7m2G9QfB8zNKBv782qK+GT4KGLmioVPdZAxp6mxGPsqfeFiG15D+P/ybHmGrV3icrzQPZwSn6gMMMyM+ydYHoUgKl9rFAjcWiQ0J9RV7pvFFNsZPA4vncrJkTKOpHR01NlHutj0c3xE7E9eBYsy0IcJnAjAH+IdM4xkrLLKwsUQu/vuJQDB9ZokcHhUjz0OdLS8MANNS1zxbQ2JqpmAYy17LO4cRzz9NawApdC+1bYrbBesnA4nmDweR7quWL+25oxUia2WSf+gMUpTfqrm8Y3b3zzq3HbVqS5LkBkF1j2VJrit/oJWDgC8HatdAd+7lOnxsaNv2OQyl8atdcpjUeEjSMA+GsTofL1KZFbg/9NcyWmEZJZZ1wej1WVzsJGtiMjHG8bTscMXFPndhhrymxJW9F+SC3FKTGChIMfuRV2iy4fK61U2lePjX2M7fnBueZYncNy5viv/XQyvg3V2cwA8I7QX8ykygOuYvsg5IEDQZoLLVTqe2VZEv2lAgl+gA4setBrBFDko57XzHawJ41+FqZBJ4P2IpjCHJF9aGf3hOXVONKnwAZ4oL9zvu42DUwC604DM6xVWAdl2AcxO01pC0wtxmmuPpozjYEyV0BrKrAZ4yH+AMxS0aChhlokB7rjNapuQ4aSP3N4ZqtdSCmcYfT3ffY1svgHjfwu8fNOcDqrHthwJ1SL0xl3pCY78UDBed6VqyNbOxsF+c224E2t6e4u4Kh4RxKA1+YDldOj7TrZoCljnskaLgJGoEOZiaNHXfFULI0qoK3cJA2/tGBmMa/nAYNuukzZ+fVGKjV+o5NpmzVdlLpwd1zjwP9L/p2nxLb0VW3VCh2QLb2Hh99xZrdBDi3kkZimptrCMVGZ3K8kGvRD+rK+VUWXRb52iUSNNwDDR7mVbMmVbkAGjzvAbhIr3fAqr7badCgx/2IYW2cRJ/Dk0QKAs12yDOdAA23U1why2iSA/Pcsk/oc8d3UZBE8Dsn1hBA7SXXFhCa3sCD8g1HiutlrikEyMvneFnPlqDhYkwD0pbZnduCU3IZNJAdmeMcj4tbGv573QANDnqSe3gsnaLq+h/ZVHiJDicU3j6hnn1ctTTUrCRxcHOBeh2Oe74TcytviL/p1vpxsI4is+fHoo1nzB92dqtJrL2QoOEeaFAX4QZGV8Y3chk0qNuml9UjXfRdgOfgflcsDdYzCp03qUXyoWmii+0dfFP8egcU3mY3dvAuzNMViwgo3f/miKXRGH/OlRcRyNc4Ui3xYTveVY3AUVwm2kZWggYDNAr4Uk6xj0nOgoaqUD9hPouQ4ip4jgfcAA167DcZnG3HuWZNVkxdWeWAsnvG7YcJMrT+7MA8e8Ei+o7joNEU8zsBGi5loQ2jvSlYVsYjXigF88AcmcdjEjTcBY0Sn/90jmSITuGbDVYNVvOn1g5kCWhM46hT6hK7R2w2Xdugwe4//p5ZPUdpzQSBomeor+CsXjbp6R0/3W1lo7Lpiirl+AduzK0stPJHjrinpq5wPM0VdhQTOF7CjXYfXusvq/99ViAeLRKBIOc1EjTMQYO6Z1abKEuSdl1aWT/O7vxof+s3tSZZvPxlnoGGL/AbRpCYKFeReg0EXrdAo7TWX2a/94wD3TeBrfb3AsruXeSA8kLhUAJFEcV8uYtzW5B18QxVOXzJDj4HrvbK/QDnu51jh3epvZcU28EyLBkJGtTaYDOw4rNjJ5MOaxx0ki42YF+IbAEN2pRoBce78Zrl2AbhdSO8U70s2n+RzRqXB8GldGI1ZtAYv9eGsltTEUoc7JXCKW9KnCZkaUxN/Nw90Ei8IDC3b7E40Ok58bBskqDZ2MkjPAON6sCvOR7s9YXVAW4yR+DOORi+M1Oy3PKDxo6H1+8Gz0eCY1e6kDfLBq0LSrVvEmQO3qLXfMlz0FDB7UbOZybaX/vAtqRPHOA/Y/eIEQINoDO3ARobMZPSkZd57OS+Qkp5zqvovoZxhNeBMgA3RUA5t7viOlMr1W2nAWNMxPkdff0BWKjF05EPs2XcHUn+cSgc4yQs7MF8ekMFAy8x0kXTYjVrZroEjWTLjEvRYHVzYU39T1KLwUZWBvfA+4A92geysvxmLh8cTxopLi9BA2MtzOZGvgHwJJYSxGnS5gxJA5iqnuSO49/1C4AGAr/xO+7fYgiAzgecSYX4EhMltw3BpTwUG1WQAcEsLZjDE3YD4WVNKx3NEEJmX51Wt9zA6xbRIxYnZRGj6Tsp1sY5Fr4bwwedUDJg3jkEJylL6Sbb85GgoQU0kcvoUYvr9y1ap5TD6ls76480Hsi4m2nQIOfjSZxIA9DgQuoaWsDR1tY10KDP2myLa3+yK4oZOZqwTwUUm90OAPEIKLe5UMDWCuO8vab27F2QaQGOJqQUh3ltsq6oY7GKxsQhjoGsfkX9EwgGMMfr4P9f6QTkgdI90VRx+apdXAw435StoEH9yYtkE6ZMg0aBVvS5wLNufWpK9bBscE8lPYvzM/UsiraVpe0AeNc+gddbkM9CyRbPp7xPGIheit0FoRnUQ1C0eByl97gcxuo019rU+OHigBG7OuW4a/VcTaNCKytGNybGQT1H7d5/j+3lTcA5i0ED51dTtz/seuISNDIMGuimgdamSBTpyloPNMRaxXPNnoNGgUpvk6ln0XbHvCQ3LRxnHef57iuQwieoqLGWJEXBbyxviF1ih1mW9B9pjLel9e1wMdCea6BBA6dVqEwcPlePBA1roJFkcTzuDkgHHuHtT5EJ0EAprAr8mCebymqjKcbfe82SAiwE9Dv4sqYC1RINrLq0GuLT9VKG9Zo0ITCkdSKE1OLypthEnZjP1vKGxLHZdLlDATTIAw/mOU8nNZ7YBwYjuYK7GQSN4mwFDVWGYUYOV4MuvvGi1d4omQINzeKAa3/dgeteC26jqRzxhlXOvOssYsJ+apFhQ0ZfNyvK91rC0b+0Kko3jFfbIsr81ogyB/4/tbmr6wceAgcWMs4yqpMob0xcDLGIMM0MI/QoCCpIYaK6omKfGcRKbsq2NR8qoKHucmu3L6kOTuLp3az3MhC+KpoSiTnoEjRsg4YqR4/fGY7fAMdYbAe80Q1SWhU8wuZ1ZQw0iJCWuNB73p7VsQYTUHasnbg7fZaeZ3aodC4us4lhZVw3JMDizscfL26NRK4HgFgPo89gbIPPzOjo6NjTizntF0rsBEp+sUNcUTi+2PPS5Ttk3eKDrxQzM7JhYPUq77SxChlawl4BD/oc2rBJq1zGtNqvYbwLQPEwvthYn5F2AKgmZ81HL20ySWmMKKmqP9ps6J43GTTGBfZD5Wc2sKZBaFMAPGFoWZkNYX857EyRJp3cD7Xb3TuYNYWWCI0BfIp9qSEDqQ3+fzEBCkF3C1Zgs66Lt7pcSKCgD4PMtKp7mZniR5CEz56SymRg3CXR7xiTLtkoVQePZGdN+Q/OesAAENgdLImXTMAidXzR0tH1Iy/mhq1VnQKN8sbYBOn7c1lI29nQcLkQUjImVXW7IPEnbmqwXmWEb8Ioo7Rhze3qNjlnP9BWB2aYgpMv8FbWr++0adMKATDmWQAMbSyb0d1d5v4M+4aBwn/LAdBY4hWFihQpUoaOgKI+14uWsmhNqrUjpue6OOsXrDUSbbABGNrwpLG9E6y5WIchXw8pUqQMEnBxcsSDYmaWCjc4QXyHlcFFrKJsFkVRdgbFv1oANPpaFGWc2/PEOg0HLI2Z8g2RIkVKkgyjlCqstsaOJM8MUKAbUrc8lfUr1haO+kUAQx3RO1wHjcb4FAdAo0e+I1KkSNFcRTx06JiSO6I6IFzkW1oTqGTXZvhPz/p1aw0r08RBQ3nb7XkCY+59TgTCx1y2cmf5tkiRktdggc2mztKhgzdKt77MidMW+fzNzJa1Ar1pvAMNrL8QB42Y65ZGU/wuR7rtAVWJfGukSMkzwdRsX90viqv993KxEAyMpx3JBIRaGhZZIqTihofEWjoEGnHXLY2G+FQHQONbzMSSb5AUKTkqWHhK6nuwRgfYBnyBf4Kl8Coo5c02iv/extRdJ6bFxxTtP3FIrDHEI+4XBg1FecfteQI77VHioJF4Qb5VUqTknhArQi3c2+IQK8JzWqW4I6ABtRdeZGd5Ii2RSEDc0ojc6b512VcIin+FWM/xxIXy9ZIiJSfdT4WUkUAULDYTCg8HFThWxHOc9+4hs9bNs2Z9BxT/WhHQmB6J+LyYK6VVtwsay0aFlo2Qb5cUKTlqbajBbRF238d4W+VasjKqAtNY58bK9SG12GBthARA4zHvNhPE2phnAzCyjtU2H6Wvr29Ye3v7Lg8oyq7IQiBXJLdkejh6LJCbvoHei2y0NooMMpYwq8k1fqza8SORGJEBGp8UDCVGW2JtNDeXtESUV2wAxvKHOjvLvZwrbdT0mgXAAObbxFlD9UVEJdsajk6gsafHYLwG45mWSLQD3IJnt86cuUc2zx/nRzYlivK6SnaZ9PyElffhGm6C4tDRUuUOfVGfU1K3dcmg3wM7Nvz+qTZF+Y3r1gYPazLGPiCLirRSdTnFlcf6gTlfNSRvOLLWUoXEzTs1XVHGZmKupO94U/xOSoVuBhgLyxtXDMlGJlCpPxKU6g0prsMNMJbA6En6HTASR26ZNnv2CAfPXdTe3T0GKfJFrAoAg4uTGJNXwZgLAPIQDpq1p13HRlA0V+B3pOq1LvPmzdse71emwdcQNMJKK02Y+aP31kbwC3A7PYFZVESBQwdKL9cE2XRZLMClNRPKh+zDB8qitC2s3Ao3eJMJWPSCCRrNht1hReibMdAm9kpsGYsxCxjr1X7e8Sg2X7LT5S8rrAtQALDO79Hd+GLobXIevHAVaSAPLyH8fSF9Id9qmTnTkRoUZC8WcT2GQqHhbZFoGz3GJ6hMEIh0nrftYN515DPwWdiJnishwLogaSh9Bl7NUtB4gNxfYJ/wYh7Y1a+wuu7wgiP8O8mnw8OHkO4ScTf4LowP0CUCO9prvKJDz1chFPWaEo1E7kPXIQPotwNX1XWYwebUTl0UNNDyoUpsNlpMzOdtxoydQNFMwR2zfAJyEjTuoc/z7+XdkiLFYUErjpBAhpV/OXpcRdkPNgKnwb+T4d9T9SxFtF5UKydyAlVC8/BnbaRaO7qAoyiH09jFy9jUywHrdyTM+Ti0qmCnehZYXcc/+Mgjhn5o7CwJymt8MmV/Szh8ACisiXjt+Dez6yDWD3wGXGj9LYVbW1t3gPOeiHOA35+OBJ28AIegP6MzehR8dxKxDBXlSCvfxcxEjAXgfFLvGW4w8L60dUYrNTqflPu1r95x0ZUJxzwG1vMMOO6Z8LkqvG5eVxh898C2cPinOJ/kjYoRaMCzfDu1JH8t33ApUpzcqXV2/QzdfzAWOJVdhAoBjvc/HTfjVtgBhpPjFhpgmYwv2VYGsU63zlAUoc5jaH0gcKrxjrR5bEBFhJ9JB93IZZR5+VQEC/j/c3ouVliXh/W6T6KipoD5Au0z02TQyfIzBBIzhQ/rey18bk0aK3RE+QoUdr0hwHd370UTHzakzTuiPDu9o+sQeq33Me7XxjSwCCs3G1zPEjjeH4zmBCC0N3UzrU5bB0X5G4KJEWjQc/YheMq3XIq13S68DOjXJC82voyw89JeAClJOzLYFTsEGJPgeFtQ+aCCQUsDrIhfkR03cTeqMRNtR0p2n2Q3rlxFFcJ7+HP/YPikqWsNzzdH1N0Ca/GRuhbK85jCiRbMjHD45yRjTM3EIkwEqdljGmjQHjErkRcN3Hc3gkL7HXz3JFRw2rHxX6xT0gWNiPIifL6TKupHcUeOVg5aGgi21JrahsfVdbeBq4jO8XWM1eB30T0Dx7xtAEgiN+lsHI6Av32DwEsy5BQlSFJZwSqA/ysE7CHmCPM4GiyManJf+q9Z+Sz5fiUHnjHNGdZyPl1T+DdyPrEoYf5wnn9oSQlw3EYdK/UY+vdNyGiNP2MSDIIAWVv4G94nMkd999S1XtZzScmdHfSTaSmXA2MBugTyPXuGxo428cQBmACtuixQgX/RGg4fpA9S0T9RpfhassvEbkwDlZtoQJu4P/qVW+Tves8EycwaqC16KvkzSQp0KypsBDIdF1Qpfk9PcSeBBirnLUZ+eNyV07Vbnpq5hlYMVcAhvfk3d3buA39fpIJ2dHzS9yrgdwmioMFCNHD/jSOfgYykZJBlxTTo+9eHiS6YqKBz3NEEhMk1RU4YUPjhH8Lv1sH42iieSb/7Fn5G19KIRK8koJGhbEspQ826UJQLTMBi0CDuEfAf5zFo4Mv5gUPHehkVAO7OzT+nBq2TrRu7oEFBqE8kH59YEqoF1M7x2RbVYhhwEyWBxiZ0qZhYYfvic4muIgPQ6MNdNMOSezg1wAtgXUvnH2a8FwfSLMVPtHgCtWCY65dqXbFAA2MJegCrcz0V9Bl8V/ucBjbJMR496ezsHDXgukqxNCCdmoCG9CpIYQIG3WFY7AL4dD5m0WBKquZLtwHM6IpQMDiJP7d3de1P1/Nl1nepS2kzKM9HREED5nEOVXrH2H9mlOd5FQwG91MVdD9oKEo3B7CStGZ0m+qBBivwnwRwN/SvnVqDgs/x4bygh8CO6dJ4H7Ci2o47zww0APwi1Ko6gT2n6F3qNYGFoYIIxn9e4rp3arq+HmhcQu5pOPx9qRWlmL0Qv6Lmux0CxOvz1NJYj3UXlr9HG2lp2SnUdYJr+R/0fbMGiWtElM+FQYOeF/3+AmuA7pmVFj6/HOb/qQ5oTOX47lxNQeqARozjGT+BKsn7k0Bvvmb9MNeexrDQQiMZVikA5BRowN8+pq6wCcxnAd49raYC1vJk6tK6mfP+n6yfPQV1RiqQysp/KfqCPlNa32GXz2ojT3pnDoLGAtxtpgZnLYMG3fFbHEtFQQMypg7V6ksE1mAbT5ZW0uc/TAaZ/uwpUFQc352jKsXwj9NAIwmIjESL4YCSfDDpmEusrj1Ngz6Nrt2lLoBGwvKcIKiNKc7qnKJXct0LSCc2AA3itnSq+FRKLio/Nc1TiG5dL4sjD6yzW6gSOUcINGjfdyzQTM7bNxvokxYFDfSDk8A7NOUyq6VgKHLM0llt4fPLUFE7DhoQa7AJGu+l1kuwBtazYHYVBSvLPEQcoPE5uiqtzAndpVrbBHQ78cyD1LLoptzSrKo8jldKYT08pEJZuBvgy/m2bljbQLN2voaXlruXeSpoYDyAKqBmW/dPoCIcU1qp4vinTdB4jrqMDmK6Q7SYRlKKb+ZBIzIDA9x6WVtmQgPJvRjTcxw01ID9WqtATgs1Sfox53t/ox5oEC4zIN6UmlGK2Y650wHQWJ6Xa0d5ejBrRY+viQc0qEJE9+AmO0V2IqCB6aeUBgVTN8/m/R4CQLJrDVwi0zmes5ZUTqMsAI2TaFzuNhsW+gvonmNlvKVmQDGzpyAzjs7pGivzIQV7quXYa5QC3L9uUCRK62LSQEOKlALel1FwbMzLtQMTPikeRFwKDEVTQdNrB4EGdXdgIsInmkJOU/BY8QzFWlhAZrCDX2SndobGNtZodChYWGb0WbXoLDqdABwEg9FVo5EwonvNSGkmBbxfTa47yDRoEBedqvx7Md3cECSxMC+izEzmFsPiN2ppfoEZcLpzhnRb+PubWMOSvIZ0zt/o0YFQYkhKTW8M5Jj1hplWyWwEWlwD40xI0aL3PZKBpxYzbjUCDScoZaTktHtKTTsUHJ/n6/pRBttX6TpsRqUKCvQUpMXAYCKhx0AOJeoKoZ/7OJVrCH6+nALHOvRLo1LGAiu16jjyVxp4R8X7cDI4qEpZeUPzZ2OFM1oQGKzlTZtERUx3qX1q/j5YBcjdNJBVBP7y6L1J9OjPaOBC3XTL6O/nYt0C7qZRaZHvqUqZXHNyLCYbQENzNWlV58jfhXPGdSdrj5aIShWOAf+e1II5el/wb2vgvl/d0tn1k4cU5btqkR1JXf1GD1D7ixXBUsV1RCWN66ZdG61L+ZxuLp5A60Obk5r11F/9vgJrSAze53WErh+KdQm7AykgJZX3K9DKGEixHwANClgvkLRueIaldpRi4C6JXigeCB+oG8hHUZUXeSFZrXjXomI38lcT+gw1pVbvu+uxalmP5wprPjQFNei+cCjjfosD6TTUniA9hvOHueFuNrU2By0ofAYMvrcFlaNellk2gEb/7nsAHPSu4VmjuA0pxoPsLYPvJfR4q2ix4JL0gtmBzCd0IdGaDaNU+Ll6mwI1wSE6xYCzilClUKLINO4pfC4xfdmINkWKlIKkXU2vCGhgxoVcSfWlo5xRd8K6zCI7Sti+ETI/6EXBE2BU6dMjv4BjXITBSnRt4DFZqb24mySBbYyZQFaPXcI5jM0QniLM10ceIqihwNgFKLHDWO4vVGKUD+tazKhDhWnWHAoBAD/PWRx4HEl3TUoFxbWibLgTmKAI1g8trDzS0OqG2gSSvgpWg8rpBZxPSXUhZvcMq8vRosB7hvcBLQczNw8CFWFggPuFySjootRbX+LSRNZgtGRg04C0LzyJB6SLJOEzi9yGadXkmuDatXPg2pPnC1xvg+4hWDM4fz2CSSlSkkxabEdq3zUlfaBSpEiRkl/WRsWAWWppbDOjnJYiRYoUKTkqkA1Sw+GTT2kla70iVooUKVKk5IjQnP9FHICxksePLEWKFClSclxoi8jJNPVua3ovDeUqWTEqRYoUKVLSBBvgYPEY5uJbocqQIkWKFCn88v9V+UlPQZNS5QAAAABJRU5ErkJggg=='
    const imgData = 'data:image/png;base64,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';

    pdf_config.addImage(imgData, 'JPEG', 5, 6, 40, 10);

    pdf_config.setFontSize(14);
    pdf_config.setTextColor("#062a73");
    pdf_config.text(`${this.user}`, m.u.ml, m.u.mt);

    // Calculate column widths based on content
    const columnStyles = {};
    const pageWidth = pdf_config.internal.pageSize.width;
    const margin = 20; // left and right margin
    const availableWidth = pageWidth - (margin * 2);

    // Calculate max content width for each column
    const allRows = [...graph_header, ...data_body];
    const contentWidths = header.map((_, colIndex) => {
      let maxLength = 0;
      allRows.forEach(row => {
        const cellContent = row[colIndex]?.toString() || '';
        // Approximate width based on character count (this is a simple approach)
        const cellWidth = cellContent.length * (colIndex === 0 ? 1.5 : 1); // Date columns might need more space
        if (cellWidth > maxLength) {
          maxLength = cellWidth;
        }
      });
      return Math.min(maxLength * 2, availableWidth / header.length); // Limit to fair share
    });

    // Normalize widths to fit available space
    const totalContentWidth = contentWidths.reduce((sum, width) => sum + width, 0);
    const scaleFactor = availableWidth / totalContentWidth;
    header.forEach((_, colIndex) => {
      columnStyles[colIndex] = {
        cellWidth: contentWidths[colIndex] * scaleFactor,
        halign: 'center'
      };
    });

    (pdf_config as any).autoTable({
      head: graph_header,
      body: data_body,
      theme: 'striped',
      useCss: true,
      margin: { left: margin, right: margin },
      tableWidth: 'auto',
      didParseCell: (data) => {
        // Skip default rendering for the last row
        if (data.row.index === data_body.length - 1) {
          data.cell.styles.fontStyle = 'bold';
          data.cell.styles.fontSize = 12;
          data.cell.styles.halign = 'center';
          data.cell.styles.textColor = [0, 0, 0];
        }
      },
      headStyles: { halign: 'center' },
      columnStyles: columnStyles, // Use the dynamically calculated column styles
      startY: pdf_config.pageCount > 1 ? pdf_config.autoTableEndPosY() + 10 : 30
    });

    // generate graph on pdf
    this.generatePrintPdf(pdf_config, e, elemt);
  }

  
  generatePrintPdf(pdf_config, e, elemt) {
    let data = document.getElementById(`${elemt}`)

    html2canvas(data).then(canvas => {

      if (e.target.name == enPdf.print) {
        pdf_config.autoPrint();
        window.open(pdf_config.output('bloburl'), '_blank');

      } else {
        if (elemt == 'report_table') {
          pdf_config.save(`pv-generation-report.pdf`);
        } else if (elemt == 'collective-table') {
          pdf_config.save(`collective-table.pdf`);
        } else if (this.device_detail.location != undefined) {
          pdf_config.save(`${(this.device_detail.location.replace(/\s+|->/gi, '_')).toLowerCase()}.pdf`);
        } else {
          pdf_config.save(`net_metering.pdf`);
        }
      }

    })
  }
}
